import React from 'react';

// reference: https://designportal.microsoft.com/media/?resetsearch=&field=metaproperty_Asset_Type&value=Illustrations&viewType=grid#
export const DeviceDesktop = (props) => (
  <svg viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M82 124.008C82 107.435 96.1982 94 113.713 94H406.287C423.802 94 438 107.435 438 124.008V305.992C438 322.565 423.802 336 406.287 336H113.713C96.1982 336 82 322.565 82 305.992V124.008Z"
      fill="url(#paint0_linear_3067_2289)"
    />
    <path
      d="M82 124.008C82 107.435 96.1982 94 113.713 94H406.287C423.802 94 438 107.435 438 124.008V305.992C438 322.565 423.802 336 406.287 336H113.713C96.1982 336 82 322.565 82 305.992V124.008Z"
      fill="url(#paint1_radial_3067_2289)"
    />
    <path
      d="M82 124.008C82 107.435 96.1982 94 113.713 94H406.287C423.802 94 438 107.435 438 124.008V305.992C438 322.565 423.802 336 406.287 336H113.713C96.1982 336 82 322.565 82 305.992V124.008Z"
      fill="url(#paint2_radial_3067_2289)"
      fillOpacity="0.9"
    />
    <path
      d="M82 124.008C82 107.435 96.1982 94 113.713 94H406.287C423.802 94 438 107.435 438 124.008V305.992C438 322.565 423.802 336 406.287 336H113.713C96.1982 336 82 322.565 82 305.992V124.008Z"
      fill="url(#paint3_radial_3067_2289)"
    />
    <path
      d="M181.089 375.39L203 335.5H317L338.457 375.591C345.944 389.58 335.809 406.5 319.942 406.5H199.495C183.527 406.5 173.401 389.385 181.089 375.39Z"
      fill="#D9D9D9"
    />
    <path
      d="M181.089 375.39L203 335.5H317L338.457 375.591C345.944 389.58 335.809 406.5 319.942 406.5H199.495C183.527 406.5 173.401 389.385 181.089 375.39Z"
      fill="url(#paint4_linear_3067_2289)"
    />
    <path
      d="M181.089 375.39L203 335.5H317L338.457 375.591C345.944 389.58 335.809 406.5 319.942 406.5H199.495C183.527 406.5 173.401 389.385 181.089 375.39Z"
      fill="url(#paint5_radial_3067_2289)"
    />
    <path
      d="M181.089 375.39L203 335.5H317L338.457 375.591C345.944 389.58 335.809 406.5 319.942 406.5H199.495C183.527 406.5 173.401 389.385 181.089 375.39Z"
      fill="url(#paint6_radial_3067_2289)"
    />
    <circle cx="260.5" cy="142.5" r="18.5" fill="url(#paint7_radial_3067_2289)" />
    <circle
      cx="260.5"
      cy="142.5"
      r="18.5"
      fill="url(#paint8_radial_3067_2289)"
      fillOpacity="0.8"
    />
    <circle cx="242" cy="356.5" r="1.5" fill="#EE7200" />
    <circle cx="316" cy="387.5" r="1.5" fill="#EE7200" />
    <circle cx="226" cy="389" r="1.5" fill="#EE7200" />
    <circle cx="294.5" cy="351" r="1.5" fill="#EE7200" />
    <circle cx="297" cy="353.5" r="1" fill="#EE7200" />
    <circle cx="213.5" cy="370" r="1" fill="#EE7200" />
    <circle cx="327.5" cy="390.5" r="1" fill="#EE7200" />
    <circle cx="261.5" cy="388.5" r="1" fill="#EE7200" />
    <defs>
      <linearGradient
        id="paint0_linear_3067_2289"
        x1="416.424"
        y1="78.6836"
        x2="198.347"
        y2="564.319"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.367698" stopColor="#E7E7E7" />
        <stop offset="0.788937" stopColor="#C5B4E3" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_3067_2289"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(250 170) rotate(113.962) scale(49.2443 23.1499)"
      >
        <stop stopColor="#C2BCC6" />
        <stop offset="0.667251" stopColor="#B3ACB8" stopOpacity="0.5" />
        <stop offset="0.992756" stopColor="#DCDCDC" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_3067_2289"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(617.654 182.132) rotate(-179.455) scale(315.161 748.64)"
      >
        <stop offset="0.475807" stopColor="#CCCECE" />
        <stop offset="0.656013" stopColor="#CCCECE" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_3067_2289"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(260 27.1263) rotate(90) scale(159.129 462.013)"
      >
        <stop offset="0.562494" stopColor="#D0D0D0" />
        <stop offset="0.871878" stopColor="#E7E7E7" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint4_linear_3067_2289"
        x1="273.139"
        y1="421.292"
        x2="273.139"
        y2="297.042"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1FFB7" />
        <stop offset="0.285864" stopColor="#D2D635" />
        <stop offset="0.615768" stopColor="#6FB12F" />
        <stop offset="1" stopColor="#5D8E02" />
      </linearGradient>
      <radialGradient
        id="paint5_radial_3067_2289"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(337.923 350.292) rotate(128.259) scale(71.5834 100.602)"
      >
        <stop stopColor="#C96000" />
        <stop offset="0.806053" stopColor="#E3F729" stopOpacity="0.2" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_3067_2289"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(259.5 329.583) rotate(90) scale(50.2917 148.942)"
      >
        <stop stopColor="#4C7601" />
        <stop offset="0.806053" stopColor="#65AA23" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_3067_2289"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(264.468 134.514) rotate(120.18) scale(37.8877)"
      >
        <stop offset="0.05" stopColor="#E8CCFF" />
        <stop offset="0.23" stopColor="#C594FF" />
        <stop offset="0.36" stopColor="#AD6CFF" />
        <stop offset="0.51" stopColor="#8E42FF" />
        <stop offset="0.78" stopColor="#E0538F" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_3067_2289"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(260.498 142.515) rotate(97.82) scale(32.8416)"
      >
        <stop offset="0.45" stopColor="white" stopOpacity="0" />
        <stop offset="0.84" stopColor="white" />
      </radialGradient>
    </defs>
  </svg>
);

DeviceDesktop.displayName = 'DeviceDesktop';
